module.exports = __webpack_public_path__ + "assets/media/morning.51e6d581.mp3";